import { initVehiclesPreview } from './vehicles-preview';
import { initfeaturedTabs } from './featured-tabs';
import { initAnchorNavOverflow } from './anchor-nav';

export function initBlocks() {
	initVehiclesPreview();
	initfeaturedTabs();
	initAnchorNavOverflow();
}